function reloadFilter() {
    let fullTextSelector = document.querySelector('.js-globalsearch-term');
    if (typeof(fullTextSelector) === 'undefined' || fullTextSelector === null)
        return;

    const fullTextModules = document.querySelector('.js-globalsearch-modules');
    const fullTextParams = document.querySelector('.js-globalsearch-params');
    prFulltext.init(
        '.js-globalsearch-term',
        fullTextModules ? fullTextModules.value.split(",") : [],
        fullTextParams ? fullTextParams.value.split(",") : []
    );
}

document.addEventListener("DOMContentLoaded", () => reloadFilter());

document.getElementById('PartialListFilter')?.addEventListener('DOMNodeInserted', () => reloadFilter());